<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <a-layout :class="'default-layout'" :hasSider="false">
        <Header>
          <Brand
            title="VCountry"
            :sider="sider"
            :siderCollapsed="isSiderCollapsed"
            @on-break-point="onBreakPoint"
          />
          <Nav
            :siderCollapsed="isSiderCollapsed"
            @on-toggle-sider="onToggleSider"
          />
        </Header>
        <a-layout-content :class="'default-main'">
          <!-- <a-row type="flex" justify="center" align="top" :class="'content'">
          <a-col :xs="20">
            -->
          <Container>
            <div class="change-locale">
              <span style="margin-right: 16px"> Language: </span>
              <a-radio-group :value="locale" @change="changeLocale">
                <a-radio-button key="en" :value="enUS">
                  English
                </a-radio-button>
                <a-radio-button key="es" :value="esES">Español</a-radio-button>
              </a-radio-group>
            </div>
            <transition name="slide-fade" mode="out-in">
              <router-view :locale="locale" />
            </transition>
          </Container>
          <!--
          </a-col>
        </a-row> -->
        </a-layout-content>
        <Footer />
      </a-layout>
    </div>
  </a-config-provider>
</template>

<script>
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import esES from 'ant-design-vue/lib/locale-provider/es_ES';
export default {
  components: {},
  name: 'app',
  data() {
    return {
      isSiderCollapsed: false,
      sider: {
        breakpoint: 'md',
        width: 200,
        collapsedWidth: 64,
      },
      locale: esES,
      esES,
      enUS,
    };
  },
  computed: {},
  methods: {
    changeLocale(e) {
      const localeValue = e.target.value;
      this.locale = localeValue;
    },
    onToggleSider(isCollapsed) {
      this.isSiderCollapsed = isCollapsed;
    },
    onBreakPoint(isCollapsed) {
      this.isSiderCollapsed = isCollapsed;
    },
  },
};
</script>

<style lang="scss" scoped>
.default {
  &-layout {
    min-height: 100vh;

    // flex-direction: column;
  }

  // &-main {
  // overflow: inherit !important;
  // }
}
</style>
